import {
  READ_LOGIN,
  LOAD_LOGIN,
  RESET_LOGIN
} from "types/Types";

const initialState = {
  useraccount_id: "",
  username: "",
  aliasuser: "",
  password: "",
  firstName: "",
  lastName1: "",
  lastName2: "",
  email: "",
  enabled: false,
  isAccountNonLocked: true,
  destinestore_id:0,
  destinestore_name:"",
  emaildestine:"",
  defaultStore: {},  
  roles: [],
  token: "",
  authorities: []
};

export function loginReducer(state = initialState, action) {
  switch (action.type) {
    case READ_LOGIN:
      return state;
    case LOAD_LOGIN: {
      const {
        id,
        username,
        aliasuser,
        password,
        firstName,
        lastName1,
        lastName2,
        email,
        enabled,
        isAccountNonLocked,
        destinestore_id,
        destinestore_name,
        emaildestine,
        defaultStore,
        roles,
        token
      } = action.payload;
      
      return {
        ...state,
        useraccount_id: id || "",
        aliasuser: aliasuser || "",
        username: username || "",
        password: password || "",
        firstName: firstName || "",
        lastName1: lastName1 || "",
        lastName2: lastName2 || "",
        email: email || "",
        enabled: enabled !== null ? enabled : true,
        isAccountNonLocked: isAccountNonLocked !== null ? isAccountNonLocked : true,
        destinestore_id: destinestore_id || "",
        destinestore_name:destinestore_name || "",
        emaildestine: emaildestine || "",
        defaultStore: defaultStore || {},
        roles: roles || [],
        token: token || ""
      };
    }
    case RESET_LOGIN:
      return initialState;
    default:
      return state;
  }
}
